import { getFormattedDate, getFormattedTime } from '@/utils/helpers'
import moment from 'moment-timezone'
import { mapGetters, mapState } from 'vuex'

export default {
	computed: {
		...mapState('venue', ['venueInfo', 'pickUpTime']),
		...mapGetters('venue', ['isWebVersionAllowASAPOption']),
		...mapState('cart', ['isAsap']),

		timeZone() {
			return this.venueInfo.timeZone
		}
	},

	methods: {
		checkIsExistingTime(pickUpTimeFrom, pickUpTimeTo) {
			const selectedDate = getFormattedDate(pickUpTimeFrom, this.timeZone)
			const selectedStartTime = getFormattedTime(pickUpTimeFrom, this.timeZone)
			const selectedEndTime = getFormattedTime(pickUpTimeTo, this.timeZone)
			const allTimeListKeys = Object.keys(this.pickUpTime)

			if (!allTimeListKeys.length) return false
			const timeListKey = allTimeListKeys.find(item => {
				return item.includes(selectedDate)
			})

			if (!timeListKey) return false
			const timeList = this.pickUpTime[timeListKey]
			const currentTimeItem = timeList.find(timeItem => {
				return timeItem.startTime.includes(selectedStartTime)
			})

			return (
				currentTimeItem && currentTimeItem.endTime.includes(selectedEndTime)
			)
		},

		pickUpValidation(pickUpTimeFrom, pickUpTimeTo) {
			if (!pickUpTimeFrom || !pickUpTimeTo) {
				return this.isWebVersionAllowASAPOption && this.isAsap
			}

			if (pickUpTimeFrom === 'ASAP') return true

			const isExistingSelectedTime = this.checkIsExistingTime(
				pickUpTimeFrom,
				pickUpTimeTo
			)

			if (!isExistingSelectedTime) {
				return false
			}

			const { pickupMinIntervalForFood } = this.venueInfo.settings
			const minStartTime = moment()
				.tz(this.timeZone)
				.add(pickupMinIntervalForFood, 'minutes')
				.format('YYYY-MM-DD HH:mm:ss.SSSZ')
			const timeDiff = moment(minStartTime, 'YYYY-MM-DD HH:mm:ss.SSSZ').diff(
				moment(pickUpTimeFrom, 'YYYY-MM-DD HH:mm:ss.SSSZ')
			)

			return timeDiff <= 0
		}
	}
}
